<template>
    <div>
            <b-form-group
                :label="this.$t('history')"
            >
                <b-table
                    ref="table"
                    :items="invoiceProvider"
                    :fields="invoicesFields"
                >
                <template #cell(action)="data">
                    <a :href="invoiceDownloadUrl(data.item)" target="_blank" v-if="data.item.type == 'invoice'">{{ $t('download') }}</a>
                </template>

                <template #cell(amount)="data">
                    $ {{data.item.amount}}
                </template>

                </b-table>
            </b-form-group>
    </div>
</template>

<script>
import Input from "@/components/form/Input"
import { loadScript } from "@paypal/paypal-js";

export default {
    name: 'Billing',
    components: {
        InputField: Input
    },
    data: function() {
        return {
          invoicesFields: ["psp_id", "date", "description", "type", "amount", "payment_status", "action"],
          paymentModal: false,
          depositAmount: 0,
          balance: 0,
          transactionReady: false
        }
    },
    methods: {
        invoiceProvider(ctx, callback) {
            this.$transactionApi.get("/transactions/billing/history").then(resp => {
                if (resp.data !== null) {
                    let items = resp.data.map(i => {
                        i.date = this.$toUserTimeZone(i.date);

                        i.amount = i.amount / 100

                        return i;
                    })

                    callback(items.reverse())
                }

                this.transactionReady = true;
            }).catch(err => {
               this.$mainDialog.msgBoxOk(this.$t('tryAgainLater'))
            })
        },

        startPayment() {
            this.paymentModal = true;
            var self = this;

            loadScript(
                {
                    "client-id": "",
                    "data-namespace": "paypal_sdk"
                }
            ).then(function(paypal) {
                paypal.Buttons({
                    createOrder: self.createOrder,
                    onApprove: self.onApprove,
                }).render("#paypal");
            })
        },


        invoiceDownloadUrl(item) {
            let baseUrl = this.$transactionApi.defaults.baseURL;

            return baseUrl + "/transactions/invoice/" + item.uuid;
        },

        getBalanceInCurrency() {
            return this.balance / 100
        }
    },

    computed: {
        createOrder: function () {
            var self = this;

            return (data, actions) => {
                return actions.order.create({
                    purchase_units: [
                        {
                        amount: {
                            value: self.depositAmount,
                        },
                        },
                    ],
                });
            }

        },

        onApprove: function () {
            var self = this;

            return (data) => {
                this.$transactionApi.post("/transactions/deposit/paypal", {
                    order_id: data.orderID,
                    amount: self.depositAmount
                }).then(resp => {
                    this.paymentModal = false;
                    this.$mainDialog.msgBoxOk(`${this.$t('transactionProcessed')}.`);
                }).catch(err => {
                    this.$mainDialog.msgBoxOk(err.response.data.message)
                })
            }
        }
    }
}
</script>
